module.exports = __webpack_public_path__ + "static/media/Group 33.45c88302.png";